var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"size"},[_c('div',{staticClass:"coinflip-result-animation",class:_vm.result == 0 ? 'heads' : 'tails'})])
}
var staticRenderFns = []

export { render, staticRenderFns }